var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 20 20",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "rgb(0,0,0)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.38268 3.07615c.37368.15478.61732.51942.61732.92388v11.99997c0 .4045-.24364.7691-.61732.9239-.37367.1548-.80379.0692-1.08979-.2168l-3.7071-3.7071h-2.58579c-.55228 0-1-.4477-1-1v-3.99997c0-.55229.44772-1 1-1h2.58579l3.7071-3.70711c.286-.286.71612-.37155 1.08979-.21677z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.6568 2.92888c.3906-.39052 1.0237-.39052 1.4143 0 1.8085 1.80855 2.9289 4.30992 2.9289 7.07107s-1.1204 5.26255-2.9289 7.07105c-.3906.3905-1.0237.3905-1.4143 0-.3905-.3905-.3905-1.0237 0-1.4142 1.4489-1.4488 2.3432-3.4474 2.3432-5.65685 0-2.20942-.8943-4.20805-2.3432-5.65686-.3905-.39052-.3905-1.02369 0-1.41421zm-2.8284 2.82843c.3905-.39053 1.0237-.39053 1.4142 0 .5259.52588.955 1.14956 1.2577 1.84227.3217.73634.4997 1.54889.4997 2.40037 0 1.65655-.6727 3.15795-1.7574 4.24265-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142c.725-.725 1.1716-1.7236 1.1716-2.82845 0-.57073-.1189-1.11105-.3324-1.59963-.2013-.46074-.4874-.87705-.8392-1.2288-.3905-.39052-.3905-1.02369 0-1.41421z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.c03a16cda0ddc5a5c76b4cb0967d339e.svg";
export { ForwardRef as ReactComponent };